<template>
  <b-row class="my-3">
    <b-col lg="7" md="9" class="mx-auto">
      <b-form-group class="text-center">
        <h4 class="mb-3">Your MPIN has been changed successfully!</h4>
        <img src="@/assets/images/auth-success.svg" alt="auth-success" class="img-fluid mt-2 mb-5">
        <b-button
          variant="primary"
          class="text-white"
          pill
          block
          @click="autoLogin"
          :disabled="isLoading">
          Proceed
        </b-button>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "ResetSuccess",
  computed: {
    ...mapGetters("auth", ["autoLoginCreds", "errors", "isLoading"])
  },
  methods: {
    ...mapActions("auth", ["login"]),
    async autoLogin() {
      await this.login(this.autoLoginCreds)
        .then(() => {
          if (this.errors === null || Object.keys(this.errors).length === 0) {
            localStorage.removeItem("active-reset-password");
            this.$router.push({ name: "Question" });
          }
        })

    }
  }
}
</script>
